import _ from 'lodash';
import { Card, ITimeMachine, Paragraph, Skeleton, Subheading } from '@treams/treams-ui';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import { AnalyticsMetric, AnalyticsMetricContainer } from './metrics/AnalyticsMetric';
import { AnalyticsGraphMetric } from './metrics/AnalyticsGraphMetric';

function AnalyticsGroupMetricSkeleton() {
	return (
		<Skeleton.Repeat count={3}>
			<Card.Skeleton>
				<Subheading.Skeleton mb={3} />

				<AnalyticsGraphMetric.Skeleton />

				<Skeleton.Repeat count={3}>
					<Paragraph.Skeleton lines={1} mt={2} />
				</Skeleton.Repeat>
			</Card.Skeleton>
		</Skeleton.Repeat>
	);
}

export function AnalyticsMetrics(props: { timeMachine: ITimeMachine; groups: graphql.Group[] }) {
	const { t } = useTranslation();
	const { data, loading } = graphql.useAnalyticsQuery({
		variables: {
			type: graphql.AnalyticsType.Workspace,
			filters: {
				startDate: props.timeMachine.current[0],
				endDate: props.timeMachine.current[1],
				groups: props.groups.map((group) => _.pick(group, ['id', 'type'])),
			},
		},
	});

	if (!loading && data) {
		return (
			<>
				{data?.analytics.metricGroups.map((metricGroup) => (
					<Card key={metricGroup.id}>
						<Subheading mb={3}>{t(`analytics.metrics.groupTitle.${metricGroup.id}`)}</Subheading>

						{metricGroup.metrics.map((metric) => (
							<AnalyticsMetricContainer key={metric.id}>
								<AnalyticsMetric
									metricGroupID={metricGroup.id}
									metric={metric as graphql.AnalyticsMetric}
									totalUsers={data.analytics.totalUsers}
									timeMachine={props.timeMachine}
								/>
							</AnalyticsMetricContainer>
						))}
					</Card>
				))}
			</>
		);
	}

	return <AnalyticsGroupMetricSkeleton />;
}
